import { render, staticRenderFns } from "./BrandAuthFormFooter.vue?vue&type=template&id=5645f1f4&"
import script from "./BrandAuthFormFooter.vue?vue&type=script&lang=js&"
export * from "./BrandAuthFormFooter.vue?vue&type=script&lang=js&"
import style0 from "./BrandAuthFormFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports